


















import {Component, Prop, Vue} from 'vue-property-decorator'
import {SelectOption} from '@/util/selectOption';
import {uniqueId} from "@/util/uniqueId";

@Component
export default class SelectInput extends Vue {
    @Prop({
        default: false
    })
    isRequired!: boolean;

    @Prop({
        default: true
    })
    showRequiredState!: boolean;

    @Prop({
        default: true
    })
    isSearchable!: boolean;

    @Prop()
    options!: SelectOption[] | string[];

    @Prop()
    label!: string;

    @Prop()
    name?: string;

    @Prop()
    error?: string | null;

    @Prop()
    value!: SelectOption | string | null;

    private uid = uniqueId();

    private get hiddenInputValue(): string | number | null {
        if (typeof this.value === 'string') {
            return this.value;
        } else if (this.value !== null) {
            return this.value.id;
        }
        return null;
    }

    optionUpdated(newOption: SelectOption | string) {
        this.$emit('input', newOption);
    }
}
